module.exports = "../dist/frontend/icons/symbols/cards/green.svg?dcb537fbae0e273dab0251e50b81fd6a";